module.exports = __webpack_public_path__ + "static/img/error.a8467b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/error.jpg
// module id = aedp
// module chunks = 1